<template>
  <div class="process-list-page">
    <div v-for="(item, i) in processListFilter" :key="i" class="process-item">
      <div class="process-item__icon">
        <span class="process-item__title">
          <span>{{ item.title }}</span>
        </span>
      </div>
      <div class="process-item__btns">
        <b-button
          v-if="!isShowByRole(item)"
          variant="outline-success"
          class="btn"
          size="sm"
          @click="handleModelClick(item)"
        >
          <span class="process-item__btns-tip">{{
            $t('_components.btns.new')
          }}</span>
        </b-button>
        <b-button
          variant="outline-secondary"
          class="btn"
          size="sm"
          @click="pageChange(item)"
        >
          <span class="process-item__btns-tip">{{
            $t('_components.btns.view')
          }}</span>
        </b-button>
        <b-button
          v-if="viewAll"
          variant="outline-primary"
          class="btn"
          size="sm"
          @click="pageChange(item, true)"
        >
          <span class="process-item__btns-tip">{{
            $t('_components.btns.all')
          }}</span>
        </b-button>
      </div>
    </div>

    <!-- 提交面试结果或者View页面 -->
    <c-drawer v-model="drawerShow">
      <!-- v-if="drawerShow && formIdList.indexOf(currentModel.formId) !== -1" -->
      <template v-for="item in processPageList">
        <component
          :is="item.component"
          v-if="drawerShow && currentModel.formId == item.formId"
          :key="item.formId"
          :form-id="currentModel.formId"
          :process-key="currentModel.processKey"
          :explain="currentModel.explain"
          @close="drawerShow = false"
        />
      </template>
    </c-drawer>
    <!-- </b-overlay> -->
  </div>
</template>

<script>
import { BButton, BOverlay } from 'bootstrap-vue'
import CDrawer from '@/components/drawer.vue'
import templateFormAPI from '@/api/templateForm/index'
import AddForm from '@/views/apply/components/add.vue'
// 调整转场表单
import WorkerFormturnSite from '@/views/worker/flow/turnSiteApply/components/turnSiteForm1.vue'
import website from '@/config/website'
import LeaveJob from '@/views/worker/flow/leaveJob/components/add.vue'
import TransferDormitory from '@/views/worker/flow/transferDormitory/components/add1.vue'
import CourseApplication from '@/views/worker/flow/courseApplication/components/add.vue'
import Course from '@/views/worker/flow/course/components/add.vue'
import PassportApplication from '@/views/worker/flow/passportApplication/components/add.vue'
import WorkerForm from '@/views/worker/flow/workerForm/components/add.vue'
import LeaveApplication from '@/views/worker/flow/leave/components/add.vue'
import Add from '@/views/worker/apply/components/add.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    BButton,
    AddForm,
    CDrawer,
    WorkerFormturnSite,
    LeaveJob,
    TransferDormitory,
    CourseApplication,
    PassportApplication,
    Course,
    WorkerForm,
    LeaveApplication,
    Add,
    // BOverlay,
  },
  data() {
    return {
      website,
      loading: false,
      drawerShow: false,
      currentModel: {},
      formList: [],
      currentPage: '',
    }
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    processListFilter() {
      const res = []
      this.processList.forEach((item) => {
        const params = item
        const findData = this.formList.find(
          (x) => String(x.formId) === String(item.formId)
        )
        if (findData) {
          params.processKey = findData.processKey
          params.explain = findData.explain
          res.push(params)
        }
      })
      console.log(this.processList, 'AAAA')
      console.log(
        this.formList.map((e) => {
          return e.formId
        }),
        'KKKK'
      )
      return res
    },
    processList() {
      const temp = [
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('turnSiteApply'),
          variant: 'primary',
          formId: '17',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          // Worker Resign
          title: this.i18n('workerResign'),
          variant: 'primary',
          formId: '24',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('transferDormitory'),
          variant: 'primary',
          formId: '26',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('courseApplication'),
          variant: 'primary',
          formId: '27',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('passportApplication'),
          variant: 'primary',
          formId: '28',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('workerForm'),
          variant: 'primary',
          formId: '30',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('course'),
          variant: 'primary',
          formId: '31',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('leave'),
          variant: 'primary',
          formId: '29',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('quickTransition'),
          variant: 'primary',
          formId: '34',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('workerRecommendProcess'),
          variant: 'primary',
          formId: '39',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('workerDismissApplication'),
          variant: 'primary',
          formId: '42',
        },
        {
          icon: 'classroom',
          iconFill: '#FFF',
          title: this.i18n('warningLetter'),
          variant: 'primary',
          formId: '105',
        },
      ]
      return temp
    },
    processPageList() {
      return [
        {
          formId: '17',
          component: 'WorkerFormturnSite',
        },
        // 离职
        {
          formId: '24',
          component: 'Add',
        },
        {
          formId: '26',
          component: 'TransferDormitory',
        },
        // 课程
        {
          formId: '27',
          component: 'CourseApplication',
          // component: 'Add',
        },
        // passport
        {
          formId: '28',
          component: 'Add',
        },
        // workerForm
        {
          formId: '30',
          component: 'Add',
        },
        {
          formId: '31',
          component: 'Course',
        },
        // 请假
        {
          formId: '29',
          component: 'Add',
        },
        {
          formId: '34',
          component: 'Add',
        },
        {
          formId: '39',
          component: 'Add',
        },
        {
          formId: '42',
          component: 'Add',
        },
        {
          formId: '105',
          component: 'Add',
        },
      ]
    },
    formIdList() {
      const formIdList = this.processPageList.map((el) => el.formId)
      return formIdList
    },
    viewAll() {
      // 只有view All 权限角色判断
      const viewAllRole = [
        'laborManager',
        'dormitoryManager',
        'workerLeaveManager',
        'coursePassportManager',
        'workerCertManager',
        'recruitTransferManager',
        'workerCoordinateManager',
        'trafficFoodManager',
      ]
      const currentRoleList = this.userAllInfo.roleAlias.split(',')
      const role = viewAllRole.filter((el) => currentRoleList.includes(el))
      return role && role.length
    },
    view() {
      // 只有view All 权限角色判断
      const viewAllRole = [
        'laborManager',
        'dormitoryManager',
        'workerLeaveManager',
        'coursePassportManager',
        'workerCertManager',
        'recruitTransferManager',
        'workerCoordinateManager',
        'trafficFoodManager',
      ]
      const currentRoleList = this.userAllInfo.roleAlias.split(',')
      const role = viewAllRole.filter((el) => currentRoleList.includes(el))
      if (role && role.length) {
        return false
      }
      return true
    },
  },
  watch: {
    drawerShow(val) {
      this.$emit('drawerShow', val)
      if (!val) {
        this.$emit('open')
      }
    },
  },
  mounted() {
    this.onLoad()
  },
  methods: {
    onLoad() {
      this.loading = true
      templateFormAPI
        .getList(1, -1, { formType: 2 })
        .then((res) => {
          const temp = res.data.data

          const formList = []
          temp.forEach((item) => {
            const config = item.configuration
              ? JSON.parse(item.configuration)
              : {}
            if (config.type === 2) {
              formList.push(item)
            }
          })
          this.$emit('getWorkerProcessList', formList)

          const arr = []
          formList.forEach((item) => {
            const params = item
            params.formName = item.baseTemplateForm.formName
            arr.push(params)
          })
          this.formList = arr
          console.log(this.formList, 'formList+==1111')
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleModelClick(item) {
      this.currentModel = item
      this.drawerShow = true
      this.$emit('close')
    },
    pageChange(item, viewAll = false) {
      const query = item
      let path = ''
      if (website.staffProcessRouter[item.formId]) {
        path = website.staffProcessRouter[item.formId]
      } else {
        path = '/worker/apply/list'
      }

      query.viewAll = viewAll
      // this.$router.push({ path: '/apply/list', query })

      const meta = this.$router.currentRoute.meta || {}
      const layout = meta.layout || ''

      this.$router.push({
        path: layout === 'public' ? `${path}/public` : path,
        query,
      })
      // if (item.formId === '17' || item.formId === '26' || item.formId === '31') {
      //   this.$router.push({ path, query })
      // }
    },
    // i18n
    i18n(param) {
      return this.$t(`_apply.process.${param}`)
    },
    // 根据角色判断是否显示按钮
    isShowByRole(item) {
      // 劳务管理员权限
      const labourSupervisorRole =
        this.userAllInfo.roleId &&
        this.userAllInfo.roleId.split(',').includes('1473914608758149122')
      const laborManagerRole =
        this.userAllInfo.roleAlias &&
        this.userAllInfo.roleAlias.split(',').includes('laborManager')
      const labourMemberRole =
        this.userAllInfo.roleAlias &&
        this.userAllInfo.roleAlias.split(',').includes('labourMember')
      const sitedirectorRole =
        this.userAllInfo.roleAlias &&
        this.userAllInfo.roleAlias.split(',').includes('sitedirector')
      const specialistManagerRole =
        this.userAllInfo.roleAlias &&
        this.userAllInfo.roleAlias.split(',').includes('specialistManager')
      const trainingAdminRole =
        this.userAllInfo.roleAlias &&
        this.userAllInfo.roleAlias.split(',').includes('training_admin')
      // 工地主任权限
      if (item.formId === '17' && !labourSupervisorRole) {
        return true
      }
      // 课程权限判断
      if (item.formId === '27' && (laborManagerRole || trainingAdminRole)) {
        return false
      }
      // 劳务管理员权限才拥有转宿舍权限判断
      if (
        (item.formId === '26' || item.formId === '31') &&
        !labourSupervisorRole
      ) {
        return true
      }
      if (item.formId === '105') {
        return true
      }
      const isWorker =
        this.userAllInfo.roleId &&
        this.userAllInfo.roleId.split(',').includes('1442420917330313217')
      const workerBaseProcessList = ['24', '28', '30', '29']
      if (workerBaseProcessList.includes(item.formId) && !isWorker) {
        return true
      }
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
.process-list-page {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  .process-item {
    position: relative;
    width: calc((100% - 96px) / 5);

    @media (max-width: 1500px) {
      width: calc((100% - 48px) / 3) !important;
    }
    min-height: 108px;
    border: 1px solid #ddd;
    display: inline-block;
    // padding-top: 1rem;
    // margin: 1rem;
    border-radius: 8px;
    cursor: pointer;

    color: #fff;
    &__icon {
      display: flex;
      flex-flow: column;
      align-items: center;
      justify-content: center;
      height: 50px;
      padding: 0px 16px;
      border-radius: 8px 8px 0px 0px;
      background: var(
        --Linear-Purple,
        linear-gradient(72deg, #6d41ff 3.64%, #2ba2d9 96.85%)
      );
    }
    &__btns {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 14px 16px;
      // margin-top: 1rem;
      display: flex;
      justify-content: space-around;
      gap: 16px;
      background: #fff;
      border-radius: 0 0 8px 8px;
      // &-tip {
      //   display: inline-block;
      //   transform: translateY(-2px) translateX(3px);
      // }
      .btn {
        width: 57px;
        flex: 1;
        height: 32px;
        border-radius: 999px;
        padding: 5px 6px;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px; /* 157.143% */
        background: #ffffff;
      }
    }
    &__title {
      font-size: 16px;
      text-align: center;
      margin: 0;
      font-weight: 600;
      line-height: 24px;

      // white-space:nowrap;
    }
    &:hover {
      box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
    }
  }
  .apply-induction .my-form {
    height: calc(100% - 140px);
  }
}
</style>
